if (window.CW_CDN_BASE) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.CW_CDN_BASE + '/'
}


